import React from 'react'
import { Button, Card, Col } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import PageHeader from 'app/components/header/PageHeader'
import CostImpressionTable from './components/CostImpressionTable'

function CostImpression() {
 return (
     <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`Pricing Impression | ${process.env.REACT_APP_PROJECT_NAME}`}</title>
      </Helmet>

      
          <CostImpressionTable />
    </>
  )
}

export default CostImpression

